import { render, staticRenderFns } from "./KeyFeatures.vue?vue&type=template&id=cc9434d2&scoped=true&"
import script from "./KeyFeatures.vue?vue&type=script&lang=js&"
export * from "./KeyFeatures.vue?vue&type=script&lang=js&"
import style0 from "./KeyFeatures.vue?vue&type=style&index=0&id=cc9434d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9434d2",
  null
  
)

export default component.exports